module.exports = __webpack_public_path__ + "icon-safety-guide.7313ec6ad8c5a3771e38e8a96939800d.png";